export enum LoanOriginationSystemEditIntermediaryTypes {
  UpdateIntermediary = 'loanOriginationSystemEditIntermediary/updateIntermediary',
  UpdateIntermediarySuccess = 'loanOriginationSystemEditIntermediary/updateIntermediarySuccess',
  UpdateIntermediaryFailure = 'loanOriginationSystemEditIntermediary/updateIntermediaryFailure',
  UpdateIntermediaryApplications = 'loanOriginationSystemEditIntermediary/updateIntermediaryApplications',
  UpdateIntermediaryApplicationsSuccess = 'loanOriginationSystemEditIntermediary/updateIntermediaryApplicationsSuccess',
  UpdateIntermediaryApplicationsFailure = 'loanOriginationSystemEditIntermediary/updateIntermediaryApplicationsFailure',
}
